import type { GenieKnowledgeEntry } from '../../types';

export const peronealNeuropathy: GenieKnowledgeEntry = {
  id: 'peroneal_neuropathy',
  name: 'Neuropatía Peronea',
  category: 'neuropatico',
  conversation: {
    headline:
      'Atrapamiento en cabeza del peroneo (fibular). Pie caído con preservación de tibial posterior.',
    edxHighlights: [
      'LMD peroneo prolongada + caída de CMAP en EDB',
      'Estudios segmentarios en cabeza del peroneo confirman localización',
      'SNAP peroneo superficial puede estar reducido',
      'EMG: fibrilaciones en EDB/tibial anterior',
    ],
    pearls: [
      'Diferenciar de radiculopatía L5: muestrear glúteo medio y paraespinales L5.',
      'Compresión externa crónica (yeso, posición quirúrgica) es causa frecuente.',
    ],
    nextSteps: [
      'Evaluar tibial vs peroneo para confirmar lesión focal',
      'Considerar imagen si trauma o masa en región fibular',
    ],
  },
  orientationHints: {
    temporalFit: ['acute', 'chronic'],
    whenToSuspect: 'Pie caído, dificultad para dorsiflexionar, parestesias dorso del pie',
  },
};
